<template>
	<v-layout
		row
		wrap
		justify-center
	>
		<v-flex v-show="items.length > 0" xl8>
			<v-data-iterator
				ref="iterator"
				:items="items"
				:rows-per-page-items="rowsPerPageItems"
				:pagination.sync="pagination"
				:search="search"
				:custom-filter="filterItems"
				:custom-sort="customSort"
				:hide-actions="items.length === 0"
				no-data-text="No reports available"
				no-results-text="No matching reports found"
				content-tag="v-layout"
				row
				wrap
			>
				<template v-if="items.length > 0" slot="header">
					<IteratorToolbar
						:sort-by="sortBy"
						:sort-name="sortName"
						:pagination="pagination"
						:initial-view="changeView"
						@search="search = $event"
						@change-view="changeView = $event"
						@sort="sort"
						@pagination="changeSortDirection"
					/>
				</template>
				<ReportListAndCard
					slot="item"
					slot-scope="props"
					:report="props.item"
					:card-type="changeView"
					@edit="$emit('edit', $event)"
					@archive="$emit('archive', $event)"
				/>
			</v-data-iterator>
		</v-flex>
		<v-flex
			v-if="items.length === 0 && !project.isArchived && $userCan('create_reports')"
			xs12
		>
			<ContextCard
				icon="arrow_upward"
			>
				<template slot="title">
					Create a New Report to get started.
				</template>
			</ContextCard>
		</v-flex>
		<v-flex v-if="items.length === 1" xs12>
			<ContextCard
				icon="info"
			>
				<template slot="title">
					What do you want to do next?
				</template>
				<template slot="text">
					Click <span class="body-2">View</span> to make changes or generate your first report.
					Click <span class="body-2">New Report</span> if you're ready to start on your second.
				</template>
			</ContextCard>
		</v-flex>
	</v-layout>
</template>

<script>
import IteratorMixin from '@/mixins/IteratorMixin';
import IteratorToolbar from '@/components/IteratorToolbar';
import ReportListAndCard from '@/components/Report/ReportListAndCard';
import ContextCard from '@/components/ContextCard';

export default {
	components: {
		IteratorToolbar,
		ReportListAndCard,
		ContextCard,
	},
	mixins: [IteratorMixin],
	props: {
		items: { type: Array, default: null },
	},
	data() {
		return {
			sortBy: [
				{ name: 'Last Active', value: 'lastActive' },
				{ name: 'Date Added', value: 'id' },
				{ name: 'Name', value: 'displayName' },
			],
			fuseOptions: {
				keys: ['displayName'],
				minMatchCharLength: 2,
				threshold: 0.4,
				shouldSort: true,
			},
			cardStyle: 'cardStyle_reports',
			sortStorage: 'sort_reports',
		};
	},
	computed: {
		project() {
			return this.$store.get('projects/currentProject');
		},
	},
	watch: {
		pagination: {
			handler() {
				// Work around needed to guarentee iterator has updated its items to the current page
				// otherwise we may get nothing or the previous page items
				setTimeout(() => {
					this.getReportStats();
				}, 100);
			},
		},
	},
	methods: {
		getReportStats() {
			if (!this.$refs.iterator) {
				return;
			}

			const current = [];
			this.$refs.iterator.filteredItems.forEach((item) => {
				current.push(item.id);
			});
		},
	},
};
</script>
